import _ from 'lodash';

export const sortByName = (array: Array<Object>) => _.sortBy(array, 'name');
